module.exports = __webpack_public_path__ + "img/linkedin-logo.0ee6f4b9.svg";